var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-content',{staticClass:"bc",attrs:{"padding":""}},[_c('ion-header',[_vm._v(" ERAU Live ADS-B 0.0.6 ")]),_c('ion-grid',{staticStyle:{"height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }